import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/guards';
import { ChangesNotSavedGuard } from '../shared/changes-not-saved';
import { ApplicationComponent } from './application.component';
import {
    ApplicationSubmittedComponent,
    BackgroundComponent,
    DisclosureComponent,
    PersonalInformationComponent,
    YourEducationComponent
} from './pages';
import { ApplicationConfirmationComponent } from './pages/application-confirmation/application-confirmation.component';

const routes: Routes = [
    {
        path: ':clientCode/application',
        component: ApplicationComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'personal-information',
                component: PersonalInformationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'background',
                component: BackgroundComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'your-education',
                component: YourEducationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            {
                path: 'disclosure',
                component: DisclosureComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            { path: '', redirectTo: 'personal-information', pathMatch: 'full' }
        ]
    },
    {
        path: ':clientCode/application-submitted',
        component: ApplicationSubmittedComponent,
        canActivate: [AuthGuard]
    },
    {
        path: ':clientCode/application-confirmed',
        component: ApplicationConfirmationComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ApplicationRoutingModule {}
